namespace Ir.Components.Workbook.WorkbookTabMoveCopy {
    interface IWorkbookTabMoveCopyViewModel {
        listOptions: DevExpress.ui.dxList.Properties;

        itemTemplate: Function;
        copyTab: Function;
        save: Function;
    }
    interface IWorkbookTabMoveCopyParams {
        popup: DevExpress.ui.dxPopup;
        tabId: number;
        callback: (obj) => boolean;
    }
    class ItemTabMoveCopyViewModel {
        initialTabId: number;
        id: number;
        initialName: string;
        name: string;
        order: number;
        icon: string;
        iconClass: string;
        hiddenTab: boolean;
        clone: boolean;
        tabConfig: WorkbookTabConfig;
        isDefaultTab: boolean;

        constructor(data) {
            this.id = data.id;
            this.initialTabId = data.initialTabId || this.id;
            this.name = data.name;
            this.order = data.order;
            this.icon = data.icon;
            this.iconClass = data.iconClass;
            this.hiddenTab = data.hiddenTab;
            this.initialName = data.initialName || this.name;
            this.clone = data.clone || false;
            this.tabConfig = data.tabConfig;
            this.isDefaultTab = data.isDefaultTab || false;
        }
    }

    export function getViewModel(this: IWorkbookTabMoveCopyViewModel, params: IWorkbookTabMoveCopyParams) {
        let listComponent: DevExpress.ui.dxList = null;

        let firstIndexChanged = 0;
        let dataSource = workbook.workbookConfig.workbookHelper.workbookTabsDataSource().map((x) => {
            return new ItemTabMoveCopyViewModel({
                id: x.tabId,
                name: x.tab().name(),
                order: x.tab().order(),
                icon: x.tab().icon(),
                iconClass: x.iconClass,
                hiddenTab: x.tab().tabConfig.hiddenTab(),
                clone: false,
                tabConfig: x.tab().tabConfig,
                isDefaultTab: x.tab().isDefaultTab()
            })
        });
        this.listOptions = {
            width: "100%",
            height: 300,
            dataSource: dataSource,
            itemTemplate: function (itemData) {
                return this.itemTemplate(itemData)
            }.bind(this),
            onInitialized(e) {
                listComponent = e.component;
            },
            onItemReordered({ fromIndex, toIndex, component }) {
                if (fromIndex < firstIndexChanged) {
                    firstIndexChanged = fromIndex;
                }
                else if (toIndex < firstIndexChanged) {
                    firstIndexChanged = toIndex;
                }

                const [element] = dataSource.splice(fromIndex, 1);
                // Insert the element at the toIndex
                dataSource.splice(toIndex, 0, element);

                let order = 0;
                for (let item of dataSource) {
                    item.order = order++;
                }
            },
            itemDragging: {
                allowReordering: true,
                dropFeedbackMode: 'indicate',
            }
        }

        this.itemTemplate = function (this: IWorkbookTabMoveCopyViewModel, itemData, itemIndex, abc) {
            let itemElement = $(`<div class="item-tab" data-bind="style: { backgroundColor: $data.item.tabConfig.backgroundColor() }">`);

            let $defaultTab = $(`<i class="ms" style="color: #ffc107;" data-bind="visible: $data.item.isDefaultTab">star</i>`);
            itemElement.append($defaultTab);

            let $icon = $('<i data-bind="style: { color: $data.item.tabConfig.fontColor() }">').text(itemData.icon);
            if (itemData.iconClass) {
                $icon.addClass(itemData.iconClass);
            }
            else {
                $icon.addClass("ms");
            }
            itemElement.append($icon);

            let $span = $(`<span data-bind="text: $data.item.name, style: { color: $data.item.tabConfig.fontColor() }, attr: { title: $data.item.name }"></span>`);
            itemElement.append($span);

            if (itemData.hiddenTab) {
                let $eyeIcon = $(`<i class="ms" style="padding-left: 4px" data-bind="style: { color: $data.item.tabConfig.fontColor() }">visibility_off</i>`);
                itemElement.append($eyeIcon);
            }

            let $copyIcon = $(`<i class="ms iconCopy" title="Duplicate tab" data-bind="click: $data.onClick, style: { color: $data.item.tabConfig.fontColor() }">content_copy</i>`);
            itemElement.append($copyIcon);

            ko.applyBindings({
                item: itemData,
                onClick: function (this: IWorkbookTabMoveCopyViewModel, data) {
                    this.copyTab(data.item.id);
                }.bind(this)
            }, itemElement.get(0))

            return itemElement;
        }.bind(this)

        let clonesTabId = -50000;
        this.copyTab = function (tabId) {
            let clone = new ItemTabMoveCopyViewModel(dataSource.find(x => x.id === tabId));
            clone.clone = true
            clone.id = --clonesTabId;
            clone.order++;
            clone.isDefaultTab = false;

            let count = dataSource.filter(x => x.initialName === clone.initialName).length;
            clone.name = `${clone.initialName} Copy ${count}`;
            while (dataSource.filter(x => x.name === clone.name).length) {
                count++;
                clone.name = `${clone.initialName} Copy ${count}`;
            }

            let idx = dataSource.findIndex(x => x.id === tabId);
            dataSource.splice(idx + 1, 0, clone);

            let order = 0;
            for (let item of dataSource) {
                item.order = order++;
            }

            listComponent.option("dataSource", dataSource);
        }

        params.callback({
            save: function () {
                let clonedTabs = workbook.workbookConfig.workbookHelper.cloneTabs(dataSource.filter(x => x.clone).map((x) => {
                    return {
                        tabId: x.initialTabId,
                        name: x.name,
                        order: x.order
                    }
                }));

                for (let item of clonedTabs) {
                    workbook.workbookConfig.tabs.push(item.tab);
                    workbook.workbookConfig.workbookHelper.workbookTabsDataSource.push(item.tabDataSource);
                }

                let pendingChanges = clonedTabs.length > 0;
                for (let item of dataSource) {
                    let tab = workbook.workbookConfig.tabs().find(x => x.id() === item.id);
                    if (tab) {
                        if (!pendingChanges && tab.order() !== item.order) {
                            pendingChanges = true;
                        }

                        tab.order(item.order);
                    }
                }

                if (pendingChanges) {
                    workbook.workbookConfig.workbookHelper.saveTabsOrder();

                    if (clonedTabs.length) {
                        const lastCopy = dataSource.filter(x => x.clone).reduce((smallest, current) => {
                            return current.id < smallest.id ? current : smallest;
                        });
                        const lastTab = clonedTabs.find(x => x.tab.name() === lastCopy.name).tab;

                        lastTab.isActiveTab(true);
                    }
                
                    //reload the page because when changing the tab order, the tab panel redraws the content and we will need to refresh some properties, including the drill-down
                    document.location = `${urlConfigs.tabs}edit/${workbook.workbookConfig.workbookId()}?reloadManually=True`;
                }
            }
        });
    }
}